import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import {
  fetchLinksList,
  clearLinksList,
  applyLinkDrag,
  clearLinkDrag,
  clearDeleteLink,
  clearPatchLink,
} from 'redux/links/actions';

import {
  DragDropContext,
  Droppable,
  Draggable,
} from "react-beautiful-dnd";

import { Loader } from 'semantic-ui-react';

import CommonLinkItem from 'components/dashboard/links-content/common-link-item/CommonLinkItem';
import LinksEmptyState from 'components/dashboard/links-content/LinksEmptyState';
import CommonMessage from 'components/common/CommonMessage';

import './LinkItemsList.css';


class LinkItemsList extends Component {
  static propTypes = {
    fetchLinksList: PropTypes.func.isRequired,
    clearLinksList: PropTypes.func.isRequired,
    applyLinkDrag: PropTypes.func.isRequired,
    clearLinkDrag: PropTypes.func.isRequired,
    clearDeleteLink: PropTypes.func.isRequired,
    clearPatchLink: PropTypes.func.isRequired,
    linksList: PropTypes.arrayOf(PropTypes.shape),
    linksListError: PropTypes.object,
    linksDragSuccess: PropTypes.bool,
    deleteLinkSuccess: PropTypes.bool,
    patchLinkSuccess: PropTypes.object,
  };

  static defaultProps = {
    linksList: null,
    linksListError: null,
    linksDragSuccess: null,
    deleteLinkSuccess: null,
    patchLinkSuccess: null,
  };

  state = {
    items: null,
  };

  componentDidUpdate(prevProps) {
    // Set Current List
    if (prevProps.linksList !== this.props.linksList) {
      this.setState({ items: this.props.linksList });
    }

    // Drag and Drop
    if (
      !prevProps.linksDragSuccess &&
      prevProps.linksDragSuccess !== this.props.linksDragSuccess
    ) {
      this.props.fetchLinksList();
      this.props.clearLinkDrag();
    }

    // Delete
    if (
      !prevProps.deleteLinkSuccess &&
      prevProps.deleteLinkSuccess !== this.props.deleteLinkSuccess
    ) {
      this.props.fetchLinksList();
      this.props.clearDeleteLink();
    }

    // Patch
    if (
      !prevProps.patchLinkSuccess &&
      prevProps.patchLinkSuccess !== this.props.patchLinkSuccess
    ) {
      this.props.fetchLinksList();
      setTimeout(() => {
        this.props.clearPatchLink();
      }, 500);
    }
  };

  reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  };

  onDragEnd = result => {
    if (!result.destination) {
      return;
    }

    const items = this.reorder(
      this.state.items,
      result.source.index,
      result.destination.index
    );

    this.setState({ items }, () => {
      const form = new FormData();
      this.state.items.map(item => item.id)
        .forEach(item => form.append('order', item));
      this.props.applyLinkDrag(form);
    });
  };

  renderLinksList = () => {
    const { items } = this.state;

    return (
      <DragDropContext onDragEnd={this.onDragEnd}>
        <Droppable droppableId="droppable">
          {provided => (
            <div
              {...provided.droppableProps}
              ref={provided.innerRef}
            >
              {items && items.map((item, index) => (
                <Draggable
                  key={`${item.id}`}
                  draggableId={`${item.id}`}
                  index={index}
                >
                  {provided => (
                    <div
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                    >
                      <CommonLinkItem
                        key={`common-link-item-key-${item.id}`}
                        linkItem={item}
                      />
                    </div>
                  )}
                </Draggable>
              ))}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    );
  };

  render() {
    const { linksList, linksListError } = this.props;
    const { items } = this.state;

    return (
      <div className="link-items-list__component">
        {/* Loader */}
        {!linksList && !linksListError &&
          <Loader active />
        }

        {/* Links List */}
        {items && items.length > 0 &&
          this.renderLinksList()
        }

        {/* Empty State */}
        {items && items.length === 0 &&
          <LinksEmptyState />
        }

        {/* Fetch Links Error */}
        {linksListError &&
          <CommonMessage
            error
            errors={linksListError}
          />
        }
      </div>
    );
  }
}

const mapStateToProps = state => (
  {
    linksList: state.linksReducer.linksList,
    linksListError: state.linksReducer.linksListError,
    linksDragSuccess: state.linksReducer.linksDragSuccess,
    deleteLinkSuccess: state.linksReducer.deleteLinkSuccess,
    patchLinkSuccess: state.linksReducer.patchLinkSuccess,
  }
);

export default connect(
  mapStateToProps,
  {
    fetchLinksList,
    clearLinksList,
    applyLinkDrag,
    clearLinkDrag,
    clearDeleteLink,
    clearPatchLink,
  },
)(LinkItemsList);
